import { render } from "./EventResults.vue?vue&type=template&id=4eb3e410&scoped=true"
import script from "./EventResults.vue?vue&type=script&lang=js"
export * from "./EventResults.vue?vue&type=script&lang=js"

import "./EventResults.vue?vue&type=style&index=0&id=4eb3e410&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eb3e410"]])

export default __exports__